import React from 'react';

export default function Skeleton({
  width = '100%',
  height = 12,
  radius = 8,
  style = {},
  className = '',
  ariaHidden = true,
}) {
  return (
    <div
      className={className}
      aria-hidden={ariaHidden}
      style={{
        width,
        height,
        borderRadius: radius,
        background: 'var(--skeleton-bg)',
        border: '1px solid var(--skeleton-border)',
        animation: 'skeletonPulse 1.5s ease-in-out infinite',
        willChange: 'opacity',
        ...style,
      }}
    />
  );
}

export function ProjectCardSkeleton() {
  return (
    <div style={v.projectCard}>
      <Skeleton height={72} radius={0} />
      <div style={v.section}>
        <Skeleton width="72%" height={15} />
        <Skeleton width="54%" height={11} />
      </div>
      <div style={{ ...v.row, marginTop: 4 }}>
        <Skeleton width={64} height={16} radius={6} />
        <Skeleton width={48} height={11} />
      </div>
      <div style={v.row}>
        <Skeleton width={84} height={11} />
        <Skeleton width={58} height={11} />
      </div>
    </div>
  );
}

export function WorkspaceSkeleton() {
  return (
    <div style={v.workspaceWrap}>
      <div style={v.workspaceTop}>
        <div style={v.row}>
          <Skeleton width={70} height={28} radius={6} />
          <Skeleton width={180} height={16} />
          <Skeleton width={80} height={16} radius={10} />
        </div>
        <div style={v.row}>
          <Skeleton width={120} height={28} radius={6} />
          <Skeleton width={140} height={28} radius={6} />
        </div>
      </div>
      <div style={v.workspaceMain}>
        <div style={v.leftCol}>
          <div style={v.tabsRow}>
            <Skeleton width={88} height={28} radius={8} />
            <Skeleton width={72} height={28} radius={8} />
            <Skeleton width={96} height={28} radius={8} />
          </div>
          <div style={v.editorArea}>
            <Skeleton width="28%" height={14} />
            <Skeleton width="92%" height={12} />
            <Skeleton width="86%" height={12} />
            <Skeleton width="94%" height={12} />
            <Skeleton width="80%" height={12} />
            <Skeleton width="88%" height={12} />
          </div>
        </div>
        <div style={v.rightCol}>
          <Skeleton width="42%" height={16} />
          <Skeleton width="88%" height={12} />
          <Skeleton width="74%" height={12} />
          <Skeleton width="90%" height={12} />
          <Skeleton width="66%" height={12} />
          <div style={{ marginTop: 18 }}>
            <Skeleton width="100%" height={34} radius={8} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function TableRowSkeleton() {
  return (
    <div style={v.tableRow}>
      <Skeleton width="84%" height={12} />
      <Skeleton width={70} height={18} radius={999} />
      <Skeleton width={56} height={12} />
      <Skeleton width={44} height={12} />
      <Skeleton width={52} height={12} />
      <Skeleton width={98} height={12} />
      <div style={v.row}>
        <Skeleton width={24} height={24} radius={6} />
        <Skeleton width={24} height={24} radius={6} />
      </div>
    </div>
  );
}

export function ChatBubbleSkeleton({ align = 'left', width = '70%' }) {
  return (
    <div style={{ ...v.chatBubble, alignSelf: align === 'right' ? 'flex-end' : 'flex-start' }}>
      <Skeleton width={width} height={14} />
      <Skeleton width={`calc(${width} - 20%)`} height={12} />
      <Skeleton width={`calc(${width} - 35%)`} height={12} />
    </div>
  );
}

export function PreviewSkeleton() {
  return (
    <div style={v.previewWrap}>
      <Skeleton width="100%" height={40} radius={0} style={{ borderBottom: '1px solid var(--border)' }} />
      <div style={v.previewBody}>
        <Skeleton width="100%" height="100%" radius={12} />
      </div>
    </div>
  );
}

const v = {
  row: { display: 'flex', alignItems: 'center', gap: 8 },
  section: { display: 'flex', flexDirection: 'column', gap: 8, padding: '14px 16px 6px' },
  projectCard: {
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 14,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    minHeight: 190,
  },
  workspaceWrap: { display: 'flex', flexDirection: 'column', height: '100vh', background: 'var(--bg-primary)' },
  workspaceTop: {
    height: 52,
    borderBottom: '1px solid var(--border)',
    padding: '10px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  workspaceMain: { display: 'flex', flex: 1, minHeight: 0 },
  leftCol: { flex: 1, borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column' },
  tabsRow: { height: 46, borderBottom: '1px solid var(--border)', padding: '8px 12px', display: 'flex', gap: 6 },
  editorArea: { padding: 20, display: 'flex', flexDirection: 'column', gap: 12, flex: 1 },
  rightCol: { width: 360, padding: 16, display: 'flex', flexDirection: 'column', gap: 10 },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 100px 80px 80px 80px 120px 110px',
    padding: '9px 12px',
    alignItems: 'center',
    borderBottom: '1px solid var(--bg-card)',
  },
  chatBubble: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: '86%',
    width: '100%',
    padding: '8px 12px',
    borderRadius: 8,
    background: 'var(--bg-card)',
  },
  previewWrap: { display: 'flex', flexDirection: 'column', height: '100%', minHeight: 420 },
  previewBody: { padding: 10, flex: 1, minHeight: 0 },
};

